var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 257,
    viewBox: "0 0 238 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.718 159.969H76.6914",
    stroke: "#1e2a4a",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.255 115.572H76.6914",
    stroke: "#1e2a4a",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.906 71.2715H76.6914",
    stroke: "#1e2a4a",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.288 15V17.09C155.287 15 155.289 15 155.288 15H155.283H155.272H155.228L155.053 15.0001L154.373 15.0005L151.789 15.0018L142.565 15.0066L114.566 15.0212L86.5439 15.0358L77.29 15.0406L74.6867 15.0419L73.9951 15.0423L73.8149 15.0424H73.7679H73.7554H73.751L73.7382 15.0425C58.6351 15.1355 46.2154 20.1631 37.5741 29.1414C28.9406 38.1116 24.27 50.8262 24.27 65.9444V163.463C24.27 178.656 28.9758 191.429 37.6795 200.415C46.3912 209.409 58.9126 214.407 74.1435 214.407V212.317C74.1441 214.407 74.1429 214.407 74.1435 214.407H74.1479H74.1589H74.2033H74.3778L75.0585 214.406L77.6421 214.405L86.8649 214.402L114.861 214.391L118.32 214.39V210.21L114.859 210.211L86.8634 210.222L77.6405 210.225L75.0568 210.226L74.3761 210.227H74.2016H74.1575H74.1462H74.1435C59.8514 210.227 48.4814 205.559 40.682 197.507C32.8746 189.446 28.45 177.792 28.45 163.463V65.9444C28.45 51.6887 32.8408 40.0871 40.5858 32.04C48.3219 24.002 59.5958 19.3109 73.7581 19.2224H73.7639L114.568 19.2012L142.567 19.1866L151.791 19.1818L154.375 19.1805L155.056 19.1801L155.23 19.18H155.274H155.285H155.288C169.58 19.18 180.953 23.848 188.755 31.9006C196.565 39.9613 200.992 51.6155 200.992 65.9444V119.5H205.172V65.9444C205.172 50.7507 200.463 37.9779 191.757 28.9919C183.043 19.9979 170.519 15 155.288 15Z",
    fill: "#1e2a4a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.729 213.777C196.608 213.777 216.777 193.608 216.777 168.728C216.777 143.849 196.608 123.68 171.729 123.68C146.849 123.68 126.68 143.849 126.68 168.728C126.68 193.608 146.849 213.777 171.729 213.777Z",
    stroke: "#1e2a4a",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M203.071 202.398L220.733 220.014",
    stroke: "#1e2a4a",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.d1a40a1df937f1185fc710df94cfc5f0.svg";
export { ForwardRef as ReactComponent };